// import cookie from '../../lib/cookie.js'
import '../assets/scss/hosting.scss'
import Spinner from 'vue-simple-spinner'
import Vue from "vue"
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)
export default {
	components: {
		Spinner
	},
	watch: {
		showStatus(a, b) {
			if (a !== b) {
				this.setStatusFilter();
			}
		},
		showProviders(a, b) {
			if (a !== b) {
				this.setCategoryFilter();
			}
		},
		perPage(a, b) {
			if (a !== b) {
				// this.clearSelected();
			}
		},
		currentPage(a, b) {
			if (a !== b) {
				// this.clearSelected();
			}
		},
		filter(a, b) {      
			if (a !== b) {
				// this.clearSelected();
			}
		}
	},
	data() {
			return {
				alldomains: [],
				loading:false,
				newdomains: '',
				registry: '',
				showDone:false,
				tableValues: [],
				freeservers: [],
				sortBy: 'ND_NAME',
				fields: [	
					{ key: 'ND_NAME', label: 'Domain',sortable: true },
					{ key: 'REGISTRY', label: 'Registry',sortable: true },
					{ key: 'ND_UD', label: 'Date',sortable: true },
					{ key: 'ND_STATUS', label: 'Status',sortable: true }
				],
				currentPage:1,
				displayType:null,
				pageOptions: [ 5, 10, 20, 50, 100 ],
				filter: null,
				token: '',
				rows: [],
				registries:[],
				working:false,
				totalRows: 0,
				perPage: 20,	

				limit: 5,
				currentPage: 1,
			};
	},

	created: function () {
		let that = this
		this.loading = true;
			this.getServers()
			this.getFreeServers()
			this.$http.get("/base/dns", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}})
			.then(resp => {
				if(resp.data.error) {
					alert("Connection failed")
				}
				else {
					that.registries = resp.data
				}
			})
			.catch(err => {
				alert(err)
			})
	},
	methods: {
		getServers() {
			let that = this
			this.$http.get("/domains/list", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}})
			.then(resp => {
				if(resp.data.error) {
					alert("Connection failed: " + resp.data.error)
					//resolve({'loginError':resp.data.error})
				}
				else {
					that.totalRows = parseInt(resp.data.length)
					that.rows = resp.data
					// that.domains = JSON.parse(JSON.stringify(that.rows))
					that.alldomains = that.rows
					if(that.showDone == false) {
						that.domains = that.alldomains.filter(dom => dom.ND_STATUS == 0);
						that.totalRows = that.domains.length 
					}
					else	that.domains =	JSON.parse(JSON.stringify(that.alldomains))
					that.totalPages = (that.total == 0) ? 0 : Math.ceil(that.total / that.perpage)
					// that.showInventoryChunk(start)
					this.loading = false;
				}
			})
			.catch(err => {
				// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
				alert(err)
				this.loading = false;
			})			
		},
		
		getFreeServers() {
			let that = this
			this.$http.get("/websites/free", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}})
			.then(resp => {
				if(resp.data.error) {
					alert("Connection failed: " + resp.data.error)
					//resolve({'loginError':resp.data.error})
				}
				else {
					that.freeservers = resp.data
					
				}
			})
			.catch(err => {
				// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
				alert(err)
				this.loading = false;
			})			
		},
		
		setServer(index, item, ip) {
			let that=this
			let domain = item.ND_NAME.toLowerCase();
			this.$http.post('/domains/setserver',{'ND_NAME':domain, 'ND_REGISTRY': item.ND_REGISTRY, 'id':ip},
				{ headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}})
			.then(function (response) {
				that.working = false;
				that.updateList(item,1)

				that.getFreeServers()
				return true;
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				 console.log(error)
			})

		},
		
		toggleShowDone() {
			this.showDone = (!this.showDone)
			if(this.showDone) {
				this.domains =	JSON.parse(JSON.stringify(this.alldomains))
			}
			else {
				this.domains = this.alldomains.filter(dom => dom.ND_STATUS == 0);
			}
			this.totalRows = this.domains.length 

		},
		
		transmitForm() {
			let that = this
			if(this.newdomains === '' || this.registry === '') {
				this.$toastr.Add({
					title: "Error", // Toast Title
					msg: "Please enter Domains and providers",
					position: "toast-top-center",
					type: "error"
				});
				return false
			}
			this.newdomains = this.newdomains.replace(/(\r\n)+/g,"\n")
			this.newdomains = this.newdomains.replace(/\n+/g,"\n")
			let rawdomains = this.newdomains.split("\n")
			let domains = rawdomains.map(d => d.trim())
			var specials = /[ !@#$%^&*()_+=\[\]{};':"\\|,<>\/?]/;
			for(let i in domains) {
				if(specials.test(domains[i])) {
					this.$toastr.Add({
						title: "Error", // Toast Title
						msg: "Bad content:\n" + domains[i],
						position: "toast-top-center",
						type: "error"
					});
					return false
				}				
			}
			this.working = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/domains/add',{'registry':this.registry, 'domains':domains.join(',')},headers)
			.then(function (response) {
				that.working = false;
				if(releaseEvents.error) {
					this.$toastr.Add({
						title: "Error", // Toast Title
						msg: error,
						position: "toast-top-center",
						type: "error"
					});
					return false
				}
				let warntext = ''
				let ttype = 'success'
				if(response.data.warning) {
					warntext = "\n" + response.data.warning
					ttype = 'warning'
				}
				let msg = "Added " + response.data.added + " of " + response.data.total + " domains" + warntext
				that.$toastr.Add({
					title: "Success", // Toast Title
					msg: msg,
					position: "toast-top-center",
					type: ttype
				});
				that.getServers()
				console.log(response)
				return true;
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				that.showeditor = false;
				 console.log(error)
			})
		},
		
		toggleStatus(id, entry) {
			var that = this
			console.log(that.showDone)
			this.working = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/domains/edit',{ND_NAME: entry.ND_NAME},headers)
			.then(function () {
				if(that.domains[id].ND_STATUS == 1) {
					that.domains[id].ND_STATUS = 0;
				}
				else {
					console.log(that.showDone)
					that.updateList(entry,1)
				}
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				that.showeditor = false;
				 console.log(error)
			})
			// alert(entry.s_id + "!!")
		},
		
		updateList(data,status) {
			for(let i=0;i < this.alldomains.length;i++) {
				if(this.alldomains[i].ND_NAME === data.ND_NAME) {
					this.alldomains[i].ND_STATUS = status
					break
				}
			}
			if(this.showDone == false) {
				this.domains = this.alldomains.filter(dom => dom.ND_STATUS == 0);
				this.totalRows = this.domains.length 
			}
	
		}
	}
}
